import React from 'react';

import { useLocation } from "react-router-dom";
import { useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';

import DataTable from '../../containers/DataTable'
import { Card } from 'react-bootstrap'
import DashboardOptions from "../Dashboard/DashboardOptions";

import dashboardAPICall from '../../app/apiCalls/dashboardAPICall'
import { cpc_dashboard_list } from '../../app/apiEndpoints'
import { tableTypes } from '../../app/settings';

import Moment from 'moment';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CPCDashboardTable = (props) => {
    let query = useQuery();
    const history = useHistory();
    const [data, setData] = useState([])

    const startDate = query.get("startDate")
    const endDate = query.get("endDate") 

    const tableID = "dashboard"
    const tableFields = ["Subpid", "# of Clicks", "Cost ($)"]

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const companyName = useSelector((state) => state.user.company.name)
    const rowID = useSelector((state) => state.currentClientID)

    const onClick = (e) => {
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        history.push(`/cpc/${rowID}/?startDate=${startDate || (Moment().add(-30, 'days').format('MM/DD/YYYY'))}&endDate=${endDate || (Moment().format('MM/DD/YYYY'))}`)

    }

    useMemo(() => {
        const getData = async () => {
            const data = await dashboardAPICall(cpc_dashboard_list, 
                {
                    'requester': userID, 
                    'company': companyID,
                    'startDate': startDate || (Moment().add(-30, 'days').format('MM/DD/YYYY')), 
                    'endDate': endDate || (Moment().format('MM/DD/YYYY'))
                })
            setData(data.dashboards)
        }
        getData()
    }, [userID, companyID, startDate, endDate])

    const tableData = () => {
        if(!data || data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach(row => {
            rows.push({'id': row.subpid, 'values': [
                row.subpid,
                row.clicks,
                row.cost
            ]});
        });
        return rows
    }
    
    const csvData = () => {
        if(data.length === 0) return []
        const dataRows = []
        dataRows.push(tableFields)
        data.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push(values);
        });
        return dataRows
    }

    const csvFileName = () => {
        return companyName && companyName.length > 0 ? `${companyName.replaceAll(" ", "_")}_CPC_Overview.csv` : 'CPC_Overview.csv'
    }

    return (
        <>
        <Card.Body>
        <DashboardOptions 
            dashID="test"
            startDate={startDate || (Moment().add(-30, 'days').format('MM/DD/YYYY'))}
            endDate={endDate || (Moment().format('MM/DD/YYYY'))}
            formAction={`/cpc/`} 
            csvData={csvData()}
            csvFileName={csvFileName()} />
        </Card.Body>
        <DataTable 
        hover={true} 
        tableID={tableID} 
        fieldNames={tableFields} 
        dataRows={tableData()} 
        onClick={onClick} 
        tableSettings={tableTypes.None} 
        currentRowID={rowID} />
        </>
    )
}

export default connect(state => ({...state}))(CPCDashboardTable)